var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Remove") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MOCKS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cart---M---Shop---1-Product-Copy-13",
    transform: "translate(-106.000000, -260.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Remove",
    transform: "translate(106.000000, 260.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    stroke: "#000000",
    fill: "#FFFFFF",
    cx: 10,
    cy: 10,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85867662,14.127844 L9.99999031,10.9867783 L12.6040357,13.5908237 L13.1410561,14.127844 C13.2202776,14.2070408 13.3490157,14.2070408 13.4282124,14.127844 L14.0028227,13.5532337 C14.0820195,13.474037 14.0820195,13.3452989 14.0028227,13.2660774 L10.861757,10.1250116 L13.4658024,7.52096624 L14.0028227,6.98394588 C14.0820195,6.90472435 14.0820195,6.77598625 14.0028227,6.69678951 L13.4282124,6.12217922 C13.3490157,6.04298248 13.2202776,6.04298248 13.1410561,6.12217922 L9.99999031,9.26324495 L6.85892458,6.12193126 C6.77970304,6.04270973 6.65096494,6.04270973 6.5717682,6.12193126 L5.99690995,6.69651676 C5.91768842,6.7757383 5.91768842,6.90447639 5.99690995,6.98369793 L9.13822365,10.1250116 L5.99690995,13.2660774 C5.91768842,13.3452989 5.91768842,13.474037 5.99690995,13.5532337 L6.57149545,14.127844 C6.65071699,14.2070408 6.77945508,14.2070408 6.85867662,14.127844 Z",
    id: "t",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.ea2d546005af521a786009b659b3894e.svg";
export { ForwardRef as ReactComponent };